
        import 'Modal.7cd2fc9.css-module'
        export default {"Modal":"Modal_Modal_7cd2fc9"}
    